import axios from 'axios'
import download from 'downloadjs'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

// Order picking slip PDF, shared by the Orders and Retailers Orders pages.
export default {
  data() {
    return {
      downloadingPdf: false,
    }
  },
  methods: {
    getPdfDownloadTooltip(item) {
      if (item.pdf_downloaded_at) {
        return `PDF downloaded by ${item.pdf_downloaded_by__fullname || '-'} on ${this.formatedDate(item.pdf_downloaded_at, 'DD-MM-YYYY hh:mm A')}`
      }
      return 'Download PDF'
    },
    // Resolves true when a PDF was downloaded, false when cancelled or failed.
    async downloadOrdersPdf(ids, force = false) {
      this.downloadingPdf = true
      try {
        const res = await axios.post('/marg/download_orders_pdf', { order_ids: ids, force }, { responseType: 'blob' })
        const fileName = this.getPdfFileName(res.headers['content-disposition'])
        download(res.data, fileName, 'application/pdf')
        return true
      } catch (error) {
        const data = await this.readBlobError(error)
        if (error?.response?.status === 409 && data?.already_downloaded) {
          this.downloadingPdf = false
          const confirmed = await this.confirmPdfRedownload(data.already_downloaded)
          return confirmed ? this.downloadOrdersPdf(ids, true) : false
        }
        this.$toast({
          component: ToastificationContent,
          props: {
            title: data?.detail || data?.error || 'Error downloading PDF!',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
        return false
      } finally {
        this.downloadingPdf = false
      }
    },
    confirmPdfRedownload(orders) {
      const h = this.$createElement
      const message = h('div', [
        h('p', 'Some of the orders are already downloaded, do you still want to download them?'),
        h('ul', { class: 'mb-0 pl-2' }, orders.map(order => h('li', [
          h('b', order.order_number),
          ` - ${order.pdf_downloaded_by__fullname || '-'}, ${this.formatedDate(order.pdf_downloaded_at, 'DD-MM-YYYY hh:mm A')}`,
        ]))),
      ])
      return this.$bvModal.msgBoxConfirm([message], {
        title: 'Already Downloaded',
        okVariant: 'primary',
        okTitle: 'Download Again',
        cancelTitle: 'Cancel',
        cancelVariant: 'outline-secondary',
        hideHeaderClose: true,
        centered: true,
      })
    },
    async readBlobError(error) {
      const data = error?.response?.data
      if (!(data instanceof Blob)) return data
      try {
        return JSON.parse(await data.text())
      } catch (e) {
        return null
      }
    },
    getPdfFileName(contentDisposition) {
      const match = /filename="?([^"]+)"?/.exec(contentDisposition || '')
      return match ? match[1] : 'Orders.pdf'
    },
  },
}
